import AttachFileIcon from '@mui/icons-material/AttachFile';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import CommentIcon from '@mui/icons-material/Comment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Badge, IconButton } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import DARDocUpload from 'src/components/StartUp/documentUpload/DARDocUpload';
import Notes from 'src/components/common/Notes';
import { DataTable } from '@pihealth/common-ui-library';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { useUser } from 'src/components/hooks/useUser';
import { useAppSelector } from 'src/store';
import { setMessage } from 'src/store/Message';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useCommonDrugAccountability } from '../useCommonDrugAccountability';
import { archLevel } from 'src/data/config';
import { GridToolbarExport } from '@mui/x-data-grid-pro';

const Dispensation: React.FunctionComponent<any> = ({ kitData }: any) => {
  const { updateDARDoc, createDARNotes, getDARNotes, getAllDespendedData, allDespendedLoading } =
    useCommonDrugAccountability();

  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { user } = useUser();
  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const dispatch = useDispatch();
  const [pageSize, setPageSize] = useState(10);
  const currentAppName = archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_TSDA_SLUG;
  const [rowsCount, setRowsCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [filterObject, setFilterObject] = useState<any>();
  const [rows, setRows] = useState([]);
  const [progress, setProgress] = useState(false);
  const { duFileUploadErrorMsg, duDocumentUploadSuccessMsg } = useFieldTranslation();
  const documentMetaData = {
    name: 'Drug accountability log',
    number: '10.03.06'
  };

  const [commentDilogOpen, setCommentDilogOpen] = useState(false);
  const handleComment = (row: any) => {
    setNotesData([]);
    setID('');
    setCommentDilogOpen(true);
    getNotesData(row.id);
    setID(row.id);
  };
  const [id, setID] = useState('');
  const [notetext, setNoteText] = useState('');
  const [notesData, setNotesData] = useState([]);
  const handleSendNote = async (_: any) => {
    if (notetext !== '') {
      sendNotesData(id);
      setNoteText('');
    }
  };
  const sendNotesData = async (id: string) => {
    try {
      await createDARNotes({
        event_id: id,
        data: {
          da_log_kit_notes: notetext,
          created_by: user
        },
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        site_id: selectedSite
      });
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    getNotesData(id);
  };
  const getNotesData = async (id: any) => {
    try {
      const res: any = await getDARNotes({ event_id: id });
      const result = res?.data;
      setNotesData(result);
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
      setNotesData([]);
    }
  };
  const formatDate = (params: any) => {
    return moment(params.row.da_log_kit_schedual_date_time).format(`${userPreferedDateFormat.toUpperCase()} h:mm A`);
  };
  useEffect(() => {
    getAllDrugEventsData(0, 10);
  }, []);
  useEffect(() => {
    if (!allDespendedLoading && (pageSize === 10 || pageSize === 20 || pageSize === 30)) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getAllDrugEventsData(0, pageSize);
      } else {
        getAllDrugEventsData(pageNumber * pageSize, pageSize);
      }
    }
  }, [pageNumber, pageSize]);

  useEffect(() => {
    if (filterObject) {
      getAllDrugEventsData(0, pageSize);
    }
  }, [filterObject]);
  const getAllDrugEventsData = async (from: number, size: number) => {
    setProgress(true);
    const allDespendedRes: any = await getAllDespendedData({
      site_id: selectedSite,
      study_id: studyId,
      kit_id: kitData.da_log_kit_id,
      data: filterObject,
      country: selectedCountry,
      application: currentAppName,
      from,
      size
    });
    if (allDespendedRes?.isSuccess) {
      let updated = [];
      if (allDespendedRes.data && allDespendedRes.data.selected_data.length > 0) {
        setRowsCount(allDespendedRes?.data.record_count);
        updated = allDespendedRes?.data.selected_data.map((item: any) => {
          return {
            id: item.event_data.id,
            documents_data: item.file_ids,
            docCount: item.file_ids.length,
            ...item.event_data
          };
        });
      } else {
        setRowsCount(0);
      }
      setRows(updated);
    } else if (allDespendedRes?.isError) {
      setRows([]);
      setRowsCount(0);
      if (allDespendedRes?.error?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (allDespendedRes?.error?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    setProgress(false);
  };
  const [uploadDilogOpen, setUploadDilogOpen] = useState<boolean>(false);
  const [uploadedFiles, setUploadedFiles] = useState<any>([]);
  const [progressDocUpload, setProgressDocUpload] = useState<boolean>(false);
  const handleFileUploadOpen = (row: any) => {
    setID(row.id);
    setUploadedFiles([...row.documents_data]);
    setUploadDilogOpen(true);
  };
  const updateDocs = async (updatedDocIds: string[], isDocDelete = false) => {
    setProgressDocUpload(true);
    try {
      await updateDARDoc({
        event_id: id,
        data: {
          uploaded_file_ids: updatedDocIds
        },
        country: selectedCountry,
        application: process.env.REACT_APP_NAME
      });
      if (isDocDelete) {
        dispatch(setMessage({ msgDetails: 'Document Deleted successfuly', severity: 'success' }));
      } else {
        dispatch(setMessage({ msgDetails: duDocumentUploadSuccessMsg, severity: 'success' }));
      }
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      } else if (isDocDelete) {
        dispatch(setMessage({ msgDetails: 'Error in Document Delete', severity: 'success' }));
      } else {
        dispatch(setMessage({ msgDetails: duFileUploadErrorMsg, severity: 'error' }));
      }
    }
    setProgressDocUpload(false);
    setUploadDilogOpen(false);
    getAllDrugEventsData(pageNumber * pageSize, pageSize);
    setID('');
  };
  const columns = [
    {
      field: 'da_log_kit_schedual_date_time',
      headerName: 'Scheduled D/T',
      minWidth: 160,
      flex: 1,
      type: 'date',
      valueGetter: formatDate
    },
    {
      field: 'da_log_kit_subject_id',
      headerName: 'Subject ID',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'da_log_kit_medication',
      headerName: 'Medication',
      minWidth: 120,
      flex: 1
    },
    {
      field: 'da_log_kit_route',
      headerName: 'Route',
      minWidth: 90,
      flex: 1
    },
    {
      field: 'da_log_kit_status',
      headerName: 'Status',
      minWidth: 90,
      flex: 1
    },
    {
      field: 'da_log_kit_dosing_delayed',
      headerName: 'Dosing Delayed?',
      flex: 1,
      renderCell: (params: any) => <>{params.row.da_log_kit_dosing_delayed === 'Yes' ? <CheckIcon /> : <ClearIcon />}</>
    },
    {
      field: 'da_log_kit_administered',
      headerName: 'Administered?',
      flex: 1,
      renderCell: (params: any) => <>{params.row.da_log_kit_administered === 'Yes' ? <CheckIcon /> : <ClearIcon />}</>
    },
    {
      field: 'da_log_kit_planned_dosage',
      headerName: 'Planned Dosage',
      flex: 1
    },
    {
      field: 'da_log_kit_actual_dosage',
      headerName: 'Actual Dosage',
      flex: 1
    },
    {
      field: 'da_log_kit_nacl_for_dilution',
      headerName: '09.% NaCl for Dilution',
      flex: 1
    },
    {
      field: 'da_log_kit_target_final_concentration',
      headerName: 'Target Final Concentration',
      flex: 1
    },
    {
      field: 'da_log_kit_start_date_time',
      headerName: 'Start Date / Time',
      flex: 1,
      valueGetter: (params: any) =>
        `${preferedDateFormat(params.row.da_log_kit_start_date_time)} ${moment(
          params.row.da_log_kit_start_date_time
        ).format('LT')}`
    },
    {
      field: 'da_log_kit_end_date_time',
      headerName: 'End Date / Time',
      flex: 1,
      valueGetter: (params: any) =>
        `${preferedDateFormat(params.row.da_log_kit_end_date_time)} ${moment(
          params.row.da_log_kit_end_date_time
        ).format('LT')}`
    },
    {
      field: 'da_log_kit_planned_frequency',
      headerName: 'Planned Frequency',
      flex: 1
    },
    {
      field: 'da_log_kit_actual_frequency',
      headerName: 'Actual Frequency',
      flex: 1
    },
    {
      field: 'da_log_kit_subject_reports',
      headerName: 'Subject Reports',
      flex: 1
    },
    {
      field: 'da_log_kit_rsg_drug_doseage',
      headerName: 'RSG Drug Dosage',
      flex: 1
    },
    {
      field: 'da_log_kit_dose_intervention',
      headerName: 'Dose Intervention',
      flex: 1
    },
    {
      field: 'da_log_kit_lot',
      headerName: 'Lot#',
      flex: 1
    },
    {
      field: 'da_log_kit_id',
      headerName: 'Kit ID',
      flex: 1
    },
    {
      field: 'da_log_kit_pharmacy',
      headerName: 'Pharmacy',
      flex: 1
    },
    {
      field: 'da_log_kit_vials_used',
      headerName: 'Vials Used',
      flex: 1
    },
    {
      field: 'da_log_kit_vials_remaining',
      headerName: 'Vials Remaining',
      flex: 1
    },
    {
      field: 'da_log_kit_vials_accounted_for',
      headerName: 'Vials Accounted for',
      flex: 1
    },
    {
      field: 'da_log_kit_expected_volume_remianining_in_vial',
      headerName: 'Expected Volume Remaining In Vial',
      flex: 1
    },
    {
      field: 'da_log_kit_actual_volume_remianining_in_vial',
      headerName: 'Actual Volume Remaining In Vial',
      flex: 1
    },
    {
      field: 'da_log_kit_volume_unaccounted_for',
      headerName: 'Volume Unaccounted for',
      flex: 1
    },
    {
      field: 'action',
      headerName: 'Action',
      minWidth: 130,
      flex: 1,
      disableExport: true,
      filterable: false,
      renderCell: (params: any) => (
        <>
          <IconButton sx={{ mr: 0.5 }} onClick={() => handleFileUploadOpen(params.row)}>
            <AttachFileIcon color="primary" />
            <Badge badgeContent={params.row.docCount} color="primary" className="smallBadgeSearch" sx={{ mt: -2.5 }} />
          </IconButton>
          <IconButton onClick={() => handleComment(params.row)}>
            <CommentIcon sx={{ color: '#2196F3' }} />
          </IconButton>
          <IconButton>
            <VisibilityIcon />
          </IconButton>
        </>
      )
    }
  ];
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `Drug Accountability Record-Dispensation ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  const dataTableProps = {
    filterMode: 'server'
  };
  const filterValues = (data: any) => {
    setFilterObject(data);
  };

  return (
    <div>
      <DataTable
        height="66vh"
        paging
        hasDefinedColumns
        hasDefinedDataGridToolbarExport
        definedGridToolbarExport={definedCustomDatGridExport}
        pageSize={pageSize}
        columns={columns}
        rows={rows}
        exportCSVName={`Drug Accountability Record-Dispensation`}
        datePreference={userPreferedDateFormat}
        loading={progress}
        setPageSize={setPageSize}
        setPageNumber={setPageNumber}
        rowsCount={rowsCount}
        page={pageNumber}
        paginationMode="server"
        dataTableProps={dataTableProps}
        filterValues={(data: any) => filterValues(data)}
      />

      <Notes
        commentDilogOpen={commentDilogOpen}
        setCommentDilogOpen={setCommentDilogOpen}
        notesData={notesData}
        handleSendNote={handleSendNote}
        notetext={notetext}
        setNoteText={setNoteText}
        permission
      />
      <DARDocUpload
        documentMetaData={documentMetaData}
        uploadDilogOpen={uploadDilogOpen}
        setUploadDilogOpen={setUploadDilogOpen}
        uploadedFiles={uploadedFiles}
        updateDocs={updateDocs}
        progress={progressDocUpload}
        permission
      />
    </div>
  );
};

export default Dispensation;
